import { mergeTemplate } from './base-template';

export const reinigungTemplate = mergeTemplate({
  name: 'Reinigung & Facility',
  icon: '🧹',
  settings: {
    primaryColor: '#0284c7',
    accentColor: '#22c55e',
    fontStack: 'dmsans',
    pageAngebot: {
      heroTitle: 'Reinigungspakete',
      heroSubtitle: 'Professionelle Sauberkeit für Gewerbe und Privat',
      packages: [
        { name: 'Unterhaltsreinigung', price: 'ab CHF 35/h', description: 'Regelmässige Reinigung für Büros und Praxen', features: 'Bodenreinigung, Sanitär, Küche, Staubwischen, Papierauffüllung', highlighted: false },
        { name: 'Grundreinigung', price: 'ab CHF 45/h', description: 'Intensive Tiefenreinigung', features: 'Komplettreinigung, Fenster, Fugen, Entfettung, Desinfektion', highlighted: true },
        { name: 'Spezialreinigung', price: 'auf Anfrage', description: 'Baureinigung, Umzug, Schadensfälle', features: 'Baureinigung, Umzugsreinigung, Wasserschaden, Desinfektion, Teppichreinigung', highlighted: false },
      ],
      ctaTitle: 'Sauberkeit auf Knopfdruck',
      ctaText: 'Fordern Sie eine unverbindliche Offerte an — wir kommen für eine kostenlose Besichtigung.',
      ctaButtonText: 'Offerte anfordern',
    },
    pageMethoden: {
      heroTitle: 'So arbeiten wir',
      heroSubtitle: 'Systematisch, gründlich, zuverlässig',
      introText: 'Professionelle Reinigung ist mehr als Putzen. Wir arbeiten nach definierten Qualitätsstandards und mit ökologischen Produkten.',
      steps: [
        { title: 'Besichtigung', description: 'Kostenlose Begutachtung der Räumlichkeiten vor Ort' },
        { title: 'Offerte', description: 'Transparentes Angebot mit detailliertem Leistungsbeschrieb' },
        { title: 'Ausführung', description: 'Geschultes Personal, professionelle Ausrüstung, termingerecht' },
        { title: 'Qualitätskontrolle', description: 'Regelmässige Kontrollen und Feedback-Gespräche' },
      ],
      tools: [
        { name: 'Ökologische Produkte', description: 'Umweltfreundliche Reinigungsmittel' },
        { name: 'Professionelle Ausrüstung', description: 'Industriestandard für beste Ergebnisse' },
        { name: 'Qualitäts-Checklisten', description: 'Standardisierte Abläufe für gleichbleibende Qualität' },
      ],
      philosophyTitle: 'Unsere Philosophie',
      philosophyText: 'Sauberkeit ist die Grundlage für Wohlbefinden und Produktivität. Wir reinigen so, dass Sie sich auf Wichtigeres konzentrieren können.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Zuverlässig, freundlich, professionell',
      introText: 'Unser geschultes Reinigungsteam arbeitet effizient und diskret — in Büros, Praxen und Privathaushalten.',
      imageUrl: '',
      timeline: [
        { year: '2010', text: 'Gründung als Reinigungsunternehmen' },
        { year: '2016', text: 'Umstellung auf ökologische Produkte' },
        { year: '2023', text: 'Erweiterung um Facility Management' },
      ],
      values: [
        { title: 'Zuverlässigkeit', description: 'Pünktlich, gründlich, jedes Mal' },
        { title: 'Ökologie', description: 'Umweltfreundliche Produkte und nachhaltige Prozesse' },
        { title: 'Fairness', description: 'Faire Löhne, faire Preise, faire Behandlung' },
      ],
      certifications: 'ISO 14001, allpura-Mitglied, RAL-Gütezeichen',
    },
  },
  components: {
    header: {
      companyName: 'Reinigung Muster',
      logoText: 'RM',
      navItems: ['Leistungen', 'Vorgehen', 'Team', 'Kontakt'],
      ctaText: 'Offerte anfragen',
    },
    hero: {
      title: 'Sauber. Zuverlässig. Professionell.',
      subtitle: 'Reinigungsservices für Gewerbe und Private.',
      primaryBtn: 'Offerte anfragen',
      secondaryBtn: 'Services',
    },
    trust: {
      items: [
        { value: 'Pünktlich', label: 'Immer' },
        { value: 'Gründlich', label: 'Standard' },
        { value: 'Flexibel', label: 'Zeiten' },
        { value: 'Versichert', label: 'Sicher' },
      ],
    },
    services: {
      title: 'Services',
      subtitle: 'Regelmässig oder einmalig.',
      items: [
        {
          icon: '🏢',
          title: 'Büroreinigung',
          text: 'Täglich, wöchentlich oder nach Bedarf.',
        },
        {
          icon: '🏠',
          title: 'Privatreinigung',
          text: 'Wohnungen, Häuser, Umzugsreinigung.',
        },
        {
          icon: '✨',
          title: 'Spezialreinigung',
          text: 'Fenster, Teppiche, Grundreinigung.',
        },
      ],
    },
    process: {
      title: 'Ablauf',
      subtitle: '',
      steps: [
        {
          num: '1',
          title: 'Anfrage',
          text: 'Objekt, Umfang, Wünsche mitteilen.',
        },
        {
          num: '2',
          title: 'Besichtigung',
          text: 'Vor-Ort-Check und transparente Offerte.',
        },
        {
          num: '3',
          title: 'Ausführung',
          text: 'Professionelle Reinigung zum vereinbarten Zeitpunkt.',
        },
        {
          num: '4',
          title: 'Qualitätskontrolle',
          text: 'Regelmässige Checks und offene Kommunikation.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Erfahrene und geschulte Reinigungsfachkräfte.',
      members: [
        {
          name: 'Sandra Keller',
          role: 'Geschäftsführerin',
          image: '',
          bio: 'Gründerin mit über 15 Jahren Erfahrung in der Gebäudereinigung. Verantwortlich für Qualitätsmanagement und Kundenbetreuung.',
        },
        {
          name: 'Marco Pereira',
          role: 'Teamleiter Gewerbereinigung',
          image: '',
          bio: 'Leitet das Gewerbe-Team und koordiniert Grossprojekte wie Bau- und Grundreinigungen.',
        },
      ],
    },
    testimonials: {
      title: 'Kundenstimmen',
      items: [
        {
          quote: 'Zuverlässig seit Jahren – wir sind sehr zufrieden.',
          author: 'Firma',
          role: 'Büro',
        },
        {
          quote: 'Nach der Umzugsreinigung haben wir die volle Kaution zurückerhalten. Sehr gründliche Arbeit.',
          author: 'M. Brunner',
          role: 'Mieterin, Zürich',
        },
        {
          quote: 'Unser Büro ist jeden Morgen tadellos sauber. Das Team ist freundlich und diskret.',
          author: 'R. Hofmann',
          role: 'Geschäftsführer, Werbeagentur',
        },
        {
          quote: 'Die Grundreinigung unserer Praxis war hervorragend. Alles wie neu — und das zu einem fairen Preis.',
          author: 'Dr. A. Meier',
          role: 'Zahnarztpraxis Winterthur',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Bieten Sie auch Einmalreinigungen an?',
          answer:
            'Ja – Umzugsreinigung, Grundreinigung und Spezialreinigungen auf Anfrage.',
        },
        {
          question: 'Welche Reinigungsmittel verwenden Sie?',
          answer:
            'Wir setzen ausschliesslich auf ökologische, biologisch abbaubare Reinigungsmittel. Auf Wunsch verwenden wir auch allergikerfreundliche Produkte.',
        },
        {
          question: 'Sind Sie versichert?',
          answer:
            'Ja, wir verfügen über eine umfassende Betriebshaftpflichtversicherung. Allfällige Schäden sind vollständig abgedeckt.',
        },
      ],
    },
    cta: {
      title: 'Offerte anfragen',
      subtitle: 'Wir melden uns innert 24h mit einer Offerte.',
    },
    footer: {
      companyName: 'Reinigung Muster',
      tagline: 'Professionelle Reinigung.',
    },
  },
});
